export enum BookingReportStatus {
  NotBilledNotPaidNotPassed = "NotBilledNotPaidNotPassed",
  NotBilledNotPaid = "NotBilledNotPaid",
  Billed = "Billed",
  Paid = "Paid",
  BilledAndPaid = "BilledAndPaid",
  Total = "Total"
}
